import React, { Component } from 'react';

class PolicyIssued extends Component {
  updatePolicyholder (policyholder) {
    this.props.setData({ ...this.props.data, policyholder: { ...this.props.data.policyholder, ...policyholder } });
  }

  updateId (id) {
    this.props.setData({ ...this.props.data, policyholder: { ...this.props.data.policyholder, id: { ...this.props.data.policyholder.id, ...id } } });
  }

  render () {
    return <div>
      <h1>Policy confirmation</h1>
      <br />
      <h5>Congratulations! Your Oats funeral policy was successfully issued!</h5>
      <br />
      <h5>Policy number</h5>
      <span className='policy-number'>{this.props.data.policyNumber}</span>
      <br />
      <p>Please check your email for your policy confirmation and documents.</p>
    </div>;
  }
}

export default PolicyIssued;



// WEBPACK FOOTER //
// ./src/components/application/policy-issued.js